import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import { useSearchResults } from "../hooks/useQueries";
import { ConfigContext, TranslateContext } from "../App";
import Loading from "../components/Loading/Loading";
import { Helmet } from "react-helmet-async";
import config from "../configuration.json";
import { renderCardsSection } from "../functions/renderComponent";

/**
 * Search results page component.
 * Displays products matching the search query.
 * Uses React Query for cached search results.
 */
const SearchResults = () => {
  const language = useContext(TranslateContext).language;
  const location = useLocation();
  const query = new URLSearchParams(location.search).get("query");
  const configuration = useContext(ConfigContext);
  const [productCards, setProductCards] = useState([]);
  const [isRendering, setIsRendering] = useState(false);

  // Use React Query hook for cached search results
  const { data: results, isLoading: dataLoading } = useSearchResults(query, language);

  useEffect(() => {
    const renderProductCards = async () => {
      if (results && results.length > 0) {
        setIsRendering(true);
        const products = {
          cardProductSection: results,
          cardType: "product-sm",
          hasFilter: true,
        };
        setProductCards(await renderCardsSection(products, false, false, language));
        setIsRendering(false);
      }
    };

    renderProductCards();
  }, [results, language]);

  const isLoading = dataLoading || isRendering;

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <Helmet>
        <title>
          {config.texts.searchResultsTitle[language]} "{query}"
        </title>
      </Helmet>

      <div className="row">
        <div className="row-container">
          <div className="column">
            <h1 className="h1-title">
              {config.texts.searchResultsTitle[language]}{" "}
              <span className="uppercase" style={{ color: configuration?.colors?.main?.hex }}>
                {query}
              </span>
            </h1>
            {results && results.length > 0 ? productCards : <p>{config.texts.noResults[language]}</p>}
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchResults;
